function add(key, value, replaceIfExists = true) {
    if (typeof value !== "string")
        value = JSON.stringify(value);
    if (check(key) && !replaceIfExists)
        return;
    localStorage.setItem(key, value);
}
function get(key) {
    if (!check(key))
        return null;
    const value = localStorage.getItem(key);
    return JSON.parse(value);
}
function check(key) {
    return localStorage.getItem(key) !== null;
}
function remove(key) {
    if (check(key))
        localStorage.removeItem(key);
}
function clear() {
    localStorage.clear();
}
export const storage = {
    add,
    get,
    check,
    remove,
    clear,
};
